/**
 * Utilidades comunes para servicios API del módulo de empleados
 * Fecha: 16 Oct 2025
 */

import { config } from '@/config/env';
import { httpRequest, type HttpError } from '@/shared/lib/http';

const API_URL = config.apiBaseUrl;

/**
 * Obtener el token de autenticación desde localStorage
 * IMPORTANTE: Usar 'access_token' que es la key usada por el sistema
 */
export const getAuthToken = (): string | null => {
  return localStorage.getItem('access_token');
};

/**
 * Interfaz para errores de API
 */
export interface ApiError {
  message: string;
  error: string;
  statusCode: number;
}

/**
 * Requests a los endpoints internos. Delega en el cliente HTTP compartido y
 * solo agrega sus mensajes propios por código, que es lo unico que la
 * distinguia del resto.
 */
export const apiRequest = async <T>(
  url: string,
  options: RequestInit = {}
): Promise<T> => {
  try {
    return (await httpRequest<T>(url, options)) as T;
  } catch (err) {
    const e = err as HttpError;
    const porCodigo: Record<number, string> = {
      401: 'No tienes autorización. Por favor inicia sesión nuevamente.',
      403: 'No tienes permisos para realizar esta acción.',
      404: 'No se encontró el recurso solicitado.',
      500: 'Error interno del servidor. Por favor intenta más tarde.',
    };
    if (porCodigo[e.status]) {
      throw { ...e, message: porCodigo[e.status] };
    }
    throw e;
  }
};

export { API_URL };
